import React from 'react';

const IconViewGallery = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <rect
        width="10.798"
        height="9.659"
        x="0.442"
        y="0.558"
        stroke="#19191A"
        rx="1.5"
        transform="matrix(.99264 .12112 -.10886 .99406 3.751 .838)"
      ></rect>
      <rect
        width="10.79"
        height="9.667"
        x="1.344"
        y="4.056"
        fill="#F8F8F8"
        stroke="#19191A"
        rx="1.5"
      ></rect>
      <path
        stroke="#19191A"
        d="M2.844 4.056h7.789a1.5 1.5 0 0 1 1.5 1.5v2.557c0 1.274-1.636 1.795-2.373.757a1.404 1.404 0 0 0-1.923-.355l-4.161 2.774c-.997.665-2.332-.05-2.332-1.248V5.556a1.5 1.5 0 0 1 1.5-1.5Z"
      ></path>
      <path
        stroke="#19191A"
        d="M3.935 5.834c.628 0 1.183.546 1.183 1.277s-.555 1.278-1.183 1.278c-.63 0-1.185-.547-1.185-1.278s.556-1.277 1.185-1.277Z"
      ></path>
    </svg>
  );
};

export default IconViewGallery;
